<script lang="ts">
    import Close from 'src/components/#common/#assets/close-black.svg'
    import { fade } from 'svelte/transition';

    export let visible = false
    export let size = void 0
</script>

{#if visible}
<style>
    body {
        overflow: hidden;
    }
</style>
<div class="modal-custom" transition:fade={{ duration: 250 }} tabindex="-1" style="
    --Close:url({Close});
">
    <div class="modal" on:click={() => { visible = false }}>
        <div class="modal-dialog modal-dialog-centered {size ? `modal-${size}` : ''}" on:click|stopPropagation={() => {}}>
            <div class="modal-content">
                <div class="modal-body">
                    <button on:click={() => { visible = false }} class="btn-close modal-custom__button-close"></button>
                    <slot name="content"></slot>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop show"></div>
</div>
{/if}

<style lang="postcss">
    .modal {
        display: block;
        overflow-y: auto;
    }

    .modal-custom {
        z-index: 9999;
        position: absolute;
    }

    .modal-content {
        border-radius: 4px;
        border: 0;
        background: white;
        text-align: left;
        box-shadow: 0 24px 32px rgba(0, 0, 0, 0.22);
    }

    .modal-body {
        padding: 15px;
        font-family: 'Rubik', sans-serif;
    }

    .modal-custom :global {
        .modal-custom__title {
            font-size: 20px;
            margin: -2px 0 20px;
            padding-right: 30px;
            border-bottom: 1px solid #d7d7d7;
            padding-bottom: 10px;
        }

        .modal-custom__text {
            font-size: 16px;
            white-space: pre-wrap;
            word-break: break-word;
        }

        .modal-custom__footer {
            text-align: right;
            margin: 20px 0 -5px;
            border-top: 1px solid #d7d7d7;
            padding-top: 15px;
        }

        .modal-custom__footer button {
            margin-left: 6px;
        }

        .btn-cancel {
            display: inline-block;
            font-size: 14px;
            color: white;
            text-decoration: none;
            font-weight: 500;
            border: 0;
            padding: 10px 20px;
            border-radius: 6px;
            box-shadow: none !important;
            background: #999999;
            line-height: 16px;
            transition: .25s;
            cursor: pointer;
        }

        .btn-cancel:hover {
            background: #878787;
        }

        .btn-primary {
            display: inline-block;
            font-size: 14px;
            color: white;
            text-decoration: none;
            font-weight: 500;
            border: 0;
            padding: 10px 20px;
            border-radius: 6px;
            box-shadow: none !important;
            background: #FF5D1C;
            line-height: 16px;
            transition: .25s;
            cursor: pointer;
        }

        .btn-primary:hover {
            background: #dd3a2e;
        }

        .modal-custom__button-close {
            position: absolute;
            background: var(--Close) no-repeat;
            top: 18px;
            right: 15px;
            font-size: 14px;
            opacity: 0.4;
            box-shadow: none !important;
            width: 10px;
            height: 10px;
            padding: .25em .25em;
            transition: .25s;
        }

        .modal-custom__button-close:hover {
            opacity: 0.7;
        }
    }

    @media(max-width: 767px) {
        .modal-dialog {
            width: 90%;
            margin: .5rem auto;
        }
    }
</style>
